import React from 'react';
import classNames from 'classnames';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import './index.scss';

interface FilterGroupProps {
  /** 业务标识，仅作 React key 使用 */
  groupKey: string;
  /** 国际化标题 key；为空时不渲染标题节点（如 My Filter 单独成行） */
  titleKey?: string;
  /** 标题文案兜底 */
  title?: string;
  /** 标题左侧数据源 icon code */
  iconCode?: string;
  /** 可选自定义类名 */
  className?: string;
  children?: React.ReactNode;
}

const FilterGroup: React.FC<FilterGroupProps> = ({
  groupKey,
  titleKey,
  title,
  iconCode,
  className,
  children,
}) => {
  const { formatMessage } = useIntlExtend();
  // 空分组兜底：所有子项被 visible:2 等过滤为 null 时整个分组不渲染
  const validChildren = React.Children.toArray(children).filter((child) => child !== '');
  if (validChildren.length === 0) {
    return null;
  }
  const titleIconSrc = iconCode ? getDataSourceIcon(iconCode) : '';
  const hasTitleIcon = Boolean(titleIconSrc);
  const groupModifier = groupKey.replace(/_/g, '-');
  const groupTitle = titleKey ? formatMessage({ id: titleKey }) : title;
  return (
    <div
      className={classNames(
        'dbi-filter-group',
        `dbi-filter-group--${groupModifier}`,
        { 'dbi-filter-group--with-title-icon': hasTitleIcon },
        className,
      )}
    >
      {groupTitle ? (
        <div className="dbi-filter-group__title">
          {titleIconSrc ? (
            <img className="dbi-filter-group__title-icon" src={titleIconSrc} alt="" aria-hidden />
          ) : null}
          <span className="dbi-filter-group__title-text">{groupTitle}</span>
        </div>
      ) : null}
      <div className="dbi-filter-group__content">{validChildren}</div>
    </div>
  );
};

export default FilterGroup;
